import fetch from '@api/axios';
import { HTTP_METHOD } from '@api/endpoints/constant';


export const apiAgent = async ({
  method = HTTP_METHOD.GET,
  endpoint,
  payload={},
  config={}}
) => {
  try {
    const httpMethod = method.toUpperCase();

    if(!Object.values(HTTP_METHOD).includes(httpMethod)) {
      throw new Error(`Invalid HTTP method: ${httpMethod}`);
    }

    const apiConfig = {
      url: endpoint,
      method: httpMethod,
      ...(Object.keys(payload).length && { data: payload }),
     ...config,
    };

    const response = await fetch(apiConfig);
    return response.data;
  } catch (err) {
    console.error("API Agent Error: ", err);
    throw err;
  }
}